import React, {useRef} from 'react';
import styled from "styled-components";
import {array_chunk, inArray, is_array} from "../../../helpers/arrays";
import PropertyGridCard from "../../property/grid/grid_card";
import LoadMore from "../../property/load.more";
import SearchHotLinks from "../search_hot_links";
import InvestmentBannerGridView from "../../../molecules/banners/investment_banner_grid_view";
import MostActiveAgencies from "../../property/components/most_active_agencies";

const SearchGridCards = ({properties, isBadeSaba, selected_filters, checkShowInvestBanner, handleBookmark, bookmarkedProperties, hotLinksItems, categories, selectedFiltersDistrictIds, userContext, handleShowProperty, handleGetProperties, windowSize, setForceShowNoResult, setContactInfo}) => {
    let hotlinksPage = 0;
    const loadMoreRef = useRef('');
    //const gridCount = (windowSize > 991) ? 3 : (windowSize > 767 ? 2 : 1);

    return (
        <React.Fragment>
            <div className="row mt-md-0">
                {
                    (properties.length) ?
                        <React.Fragment>
                            {
                                array_chunk(properties, 20).map((chunk, propertiesPage) => {
                                    return (
                                        chunk.map((property, key) => {
                                            const chunkLength = chunk.length;
                                            const loop = (key + 1);
                                            const EvenPage = (propertiesPage % 2 === 0);

                                            let $hotLinksPosition = 'end';
                                            let $hotLinksPosition2 = null;
                                            let $realtorBannerPosition = 'end';
                                            let $investmentBannerPosition = 'end';


                                            if (chunkLength >= 10) {
                                                if (chunkLength < 15) {
                                                    $hotLinksPosition = 'between';
                                                    //$realtorBannerPosition = 'end';
                                                } else if (chunkLength < 20) {
                                                    $hotLinksPosition = 'between';
                                                    $hotLinksPosition2 = 'end';
                                                    //$realtorBannerPosition = 'between';
                                                } else {
                                                    $hotLinksPosition = 'between';
                                                    $hotLinksPosition2 = 'between';
                                                    //$realtorBannerPosition = 'between';
                                                }
                                            }


                                            return (
                                                <React.Fragment>
                                                    <PropertyGridCard
                                                        property={property}
                                                        isBadeSaba={isBadeSaba}
                                                        categories={categories}
                                                        setForceShowNoResult={setForceShowNoResult}
                                                        setContactInfo={setContactInfo}
                                                        selectedFiltersDistrict={selected_filters.district_id}
                                                        selectedCityFilter={selected_filters.city_id}
                                                        handleBookmark={handleBookmark}
                                                        bookmarkedProperties={bookmarkedProperties}
                                                        handleShowProperty={handleShowProperty}
                                                    />

                                                    {
                                                        (is_array(hotLinksItems) && hotLinksItems.length) ?
                                                            array_chunk(hotLinksItems, 4).map((chunkItems, i) => {
                                                                const hotlinkEvenPage = (hotlinksPage % 2 === 0);

                                                                if (categories === 'search' &&
                                                                    hotlinkEvenPage === EvenPage &&
                                                                    (chunkItems.length && i === hotlinksPage) &&
                                                                    (
                                                                        ($hotLinksPosition === 'end' && loop >= chunkLength) ||
                                                                        ($hotLinksPosition === 'between' && loop === 10)
                                                                    )) {

                                                                    hotlinksPage += 1;

                                                                    if (hotLinksItems.length < ((hotlinksPage * 4) + 1)) {
                                                                        hotlinksPage = 0;
                                                                    }

                                                                    return (
                                                                        <div className="col-12">
                                                                            <Sections className="mx-24 mx-md-0">
                                                                                <SearchHotLinks
                                                                                    mapKey={i}
                                                                                    items={chunkItems}
                                                                                    className="border-transparent grid-view-search-hot-link"
                                                                                />
                                                                            </Sections>
                                                                        </div>
                                                                    )
                                                                }

                                                            })
                                                            : ''
                                                    }

                                                    {
                                                        (!isBadeSaba && categories === 'search' && EvenPage && $realtorBannerPosition === 'end' && loop >= chunkLength) ?
                                                            <div className="col-12 js-most-active-agency-section">
                                                                <Sections className="mx-24 mx-md-0">
                                                                    <MostActiveAgencies
                                                                        className="border-transparent grid-view-search-promote-agencies py-32 pb-md-40"
                                                                        city_id={selected_filters.city_id}
                                                                        district_id={selectedFiltersDistrictIds}
                                                                        setContactInfo={setContactInfo}
                                                                        count={(inArray(selected_filters.city_id, [3198, 17879]) ? 28 : 12)}
                                                                    />
                                                                </Sections>
                                                            </div>
                                                            : ''
                                                    }

                                                    {
                                                        (categories === 'search' && !userContext.isRealtor && checkShowInvestBanner.show_invest && !EvenPage && (($investmentBannerPosition === 'end' && loop >= chunkLength))) ?
                                                            <div className="col-12">
                                                                <Sections className="mx-24 mx-md-0">
                                                                    <InvestmentBannerGridView
                                                                        eventSection="properties"
                                                                        eventView="grid"
                                                                        isBadeSaba={isBadeSaba}
                                                                        userModality={checkShowInvestBanner}/>
                                                                </Sections>
                                                            </div>
                                                            : ''
                                                    }

                                                </React.Fragment>
                                            )
                                        })
                                    )
                                })
                            }

                        </React.Fragment>
                        : ''
                }
            </div>

            <div className="row" ref={loadMoreRef}>
                <LoadMore
                    loadMoreRef={loadMoreRef}
                    handleGetProperties={handleGetProperties}
                    className={"col-12 my-56 " + (isBadeSaba ? 'pb-56 mb-56' : '')}/>
            </div>
        </React.Fragment>
    );
};

export default React.memo(SearchGridCards);

// styles

const Sections = styled.div`
  padding: 56px 0 40px 0;

  .grid-view-search-hot-link, .grid-view-search-promote-agencies {
    padding: 0 !important;
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    padding: 32px 0;
    border-top: 1px solid ${props => props.theme.gray200};;
  }
`;